import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$axios=axios
axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.use(ElementUI);
// 6 全局配置
import settings from "@/assets/js/settings";
Vue.prototype.$settings=settings
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
